import reduce from 'lodash-es/reduce';
import some from 'lodash-es/some';
import values from 'lodash-es/values';
import { makeAutoObservable } from 'mobx';
import { TableLinkData } from 'entities/table/model/tableLinkModel';
import { v4 as uuid } from 'uuid';
import { cloneDeep, isEqual } from 'lodash-es';

export const createEmptyRow = (id: string) => ({
  id,
  name: '',
  description: '',
  url: '',
});

export class TableLinksHelper {
  private originalLinks: Record<string, TableLinkData>;
  private links: Record<string, TableLinkData>;
  public isSubmitError = false;

  constructor({ links }: { links: TableLinkData[] }) {
    this.originalLinks = reduce(
      links,
      (acc: Record<string, TableLinkData>, link) => {
        acc[link.id] = link;

        return acc;
      },
      {}
    );
    this.links = cloneDeep(this.originalLinks);
    makeAutoObservable(this);
  }

  public get linksArray() {
    return values(this.links);
  }

  public getById(id: string) {
    if (this.links[id]) {
      return this.links[id];
    }

    return null;
  }

  public isFilled(linkOrId: TableLinkData | string) {
    const link =
      typeof linkOrId === 'string' ? this.getById(linkOrId) : linkOrId;

    if (link) {
      return link.name !== '' && link.description !== '' && link.url !== '';
    }

    return false;
  }

  public get isSomeNotFilled() {
    return some(this.links, (link) => !this.isFilled(link));
  }

  public get isLastRow() {
    return this.linksArray.length === 1;
  }

  public deleteRow(id: string) {
    delete this.links[id];
  }

  public createEmpty() {
    const id = uuid();

    this.links[id] = createEmptyRow(id);
  }
  public get isChanged() {
    const isChanged = !isEqual(this.links, this.originalLinks);
    return isChanged;
  }
}
